import { LoggerService } from '@app/shared/services/logger.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConfig } from '@app/config/app.config';
import { map, first, retryWhen, tap, catchError, retry, delay } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from '@app/shared/services/http-error-handler.service';
import { HeadersSetterHelper } from '@app/shared/helpers/http-headers-setter-helper';
import { observeTypes, ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';
import { Store } from '@ngrx/store';

@Injectable()

export class AuthenticationService {
  private handleError: HandleError;
  private headerHelper: any;

  private packsSubject = new BehaviorSubject<any[]>([]);
  packs$ = this.packsSubject.asObservable();
  private loggedInOnlyQES = new BehaviorSubject<boolean>(false);
  isLoggedInOnlyQES$ = this.loggedInOnlyQES.asObservable();

  constructor(
    private http: HttpClient,
    private httpErrorHandler: HttpErrorHandler,
    private store: Store<any>,
    private logger: LoggerService
  ) {
    this.handleError = httpErrorHandler.createHandleError('AuthenticationService');
    this.headerHelper = new HeadersSetterHelper(this.store);
  }

  private options(observeType) {
    return this.headerHelper.options(observeType);
  }

  loginById(loginId: string, recaptchaResponse: string | undefined, qaKey?: string | undefined): Observable<ISpringResponseBody> {
    // loginId = (idPrefix) ? idPrefix + loginId : loginId;   TODO: Remove after some time if there are no problems

    // JSON.stringify under the hood will serialize the request body and if some of the variable are undefined they will not be included in the request body
    return this.http.post<ISpringResponseBody>(AppConfig.endpoints.authenticate.byId, { loginId, recaptchaResponse, qaKey },
      this.headerHelper.loginOptions(observeTypes.BODY))
      .pipe(
        catchError(this.handleError('login')),
        map((res: ISpringResponseBody) => {
          this.logger.log(res);
          return res;
        }));
  }

  // JSON.stringify under the hood will serialize the request body and if some of the variable are undefined they will not be included in the request body
  emergencyLogin(loginId: string, recaptchaResponse: string | undefined, qaKey?: string | undefined): Observable<ISpringResponseBody> {
    return this.http.post<ISpringResponseBody>(
      AppConfig.endpoints.emergency.sendEmergencyCode,
      { loginId, recaptchaResponse, qaKey },
      this.options(observeTypes.BODY))
      .pipe(
        first(),
        catchError(this.handleError('emergencyLogin')),
        map((res: ISpringResponseBody) => {
          this.logger.log(res);
          return res;
        }));
  }

  sendSecretKey(code: string, emergencyRequestId: string): Observable<ISpringResponseBody> {
    return this.http.post<ISpringResponseBody>(
      AppConfig.endpoints.emergency.validateEmergencyCode,
      { code, emergencyRequestId },
      this.options(observeTypes.BODY))
      .pipe(
        first(),
        catchError(this.handleError('sendSecretKey')),
        map((res: ISpringResponseBody) => {
          this.logger.log(res);
          return res;
        }));
  }

  getQRCode(): Observable<any> {
    return this.http.get<any>(AppConfig.endpoints.authenticate.getQrCode + '/', this.headerHelper.loginOptions(observeTypes.BODY))
      .pipe(
        first(),
        catchError(this.handleError('getQRCode')),
      );
  }

  loginCheck(uniqueToken: string): Observable<any> {
    return this.http.get<ISpringResponseBody>(AppConfig.endpoints.authenticate.authenticate + '/' + uniqueToken,
      this.options(observeTypes.BODY))
      .pipe(
        delay(AppConfig.repeatTimeout),
        catchError(this.handleError('loginCheck')),
        map(res => {
          if (res['status'] === 202) {
            throw 202;
          }
          return res;
        }),
        retry({ delay: 500 })

      );
  }
  updatePacks(packs: any[]) {
    this.packsSubject.next(packs);
  }
  destroySession(): Observable<ISpringResponseBody | ArrayBuffer> {
    return this.http.post(AppConfig.endpoints.authenticate.logout, {}, this.options(observeTypes.BODY))
      .pipe(
        tap((res) => console.log('logout', res)),
        first(),
        catchError(this.handleError('logout')),
        retry(2),
      );
  }

  loginOnlyQESShowProfile(isLoginWES: boolean) {
    this.loggedInOnlyQES.next(isLoginWES);
  }

  logoutOnlyQESShowProfile() {
    this.loggedInOnlyQES.next(false);
  }
}
